<template>
    <div class="text-slate-300">
        <h1 class="header-class">
            <vue-feather type="film" size="16px" class="-mb-[2px]" aria-hidden="true" />
            Flagged to Watch
        </h1>
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 p-2 w-full">
            <MovieBox
                v-for="movie in upcoming"
                :ref="`m-${movie.id}`"
                class="movie pb-8"
                :key="movie.id"
                :image="`/upcoming-movie-image/${movie.slug}-${movie.year}/jpg/250`"
                :movie="movie"
            />
        </div>

        <!-- <h2 class="header-class pl-5 pt-4">20 Recently Watched</h2>
        <div class="box flex flex-wrap justify-evenly p-3 m-2 pb-32">
            <content v-for="t in lastPlayedSorted" :key="t.row_id" class="w-full md:w-1/5 flex flex-wrap mb-16">
                <MovieBox class="movie flex-1" :title="t.title" :image="`/upcoming-movie-image/${t.slug}/jpg/200`"
                    :rawdata="t" :date="formatDate(unixTimestamp(t.last_play), 'ddd M/DD/YYYY h:mma')" :year="t.year" />
            </content>
        </div> -->
    </div>
</template>

<script>
    import MovieBox from '@/Components/MovieBox.vue';
    import GuestLayout from '@/Layouts/GuestLayout.vue';
    import { formatDate, unixTimestamp } from '@/utils/Utilities';
    import { gsap } from 'gsap/all'

    export default {
        name: "MoviesComp",
        layout: GuestLayout,
        props: ['upcoming', 'styles'],
        components: { MovieBox },
        data() {
            return {

            }
        },
        mounted() {
            gsap.fromTo('.movie',
            { y: 10, opacity: 0 },
            { y: 0, opacity: 1, stagger: .02, duration: .2},
            )
        },
        methods: {
            formatDate,
            unixTimestamp,

        }
    }
</script>
<style lang="postcss">
.movie {
    opacity: 1;
}
</style>
